import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { AsyncComponentErrorHandler } from '../../helpers/AsyncComponentErrorHandler';
import { AsyncComponentLoadingHandler } from '../../helpers/AsyncComponentLoadingHandler';
export const TimelineCommentDeleteModalAsync = Loadable({
  loader: () => import( /* webpackChunkName: "timeline-comment-delete-modal" */'./TimelineCommentDeleteModal').then(mod => mod.default),
  LoadingComponent: AsyncComponentLoadingHandler(),
  ErrorComponent: AsyncComponentErrorHandler('timeline-comment-delete-modal')
});